export const iconFontAwesomeMapsCrosshairs = (
	<i className="fa-solid fa-crosshairs"></i>
);
